export default "__VITE_ASSET__smPMu1D7__"